import { createAction, props } from '@ngrx/store';
import { MspDattoMapping } from './model';

export const loadMspDattoMappings = createAction('[MSP Datto] Load Mappings');
export const loadMspDattoMappingsSuccess = createAction(
    '[MSP Datto] Load Mappings Success',
    props<{ items: MspDattoMapping[] }>(),
);
export const loadMspDattoMappingsFailure = createAction('[MSP Datto] Load Mappings Failure', props<{ error: any }>());

export const updateMspDattoMappings = createAction(
    '[MSP Datto] Update Mappings',
    props<{ items: MspDattoMapping[] }>(),
);
export const updateMspDattoMappingsSuccess = createAction(
    '[MSP Datto] Update Mappings Success',
    props<{ items: MspDattoMapping[] }>(),
);
export const updateMspDattoMappingsFailure = createAction(
    '[MSP Datto] Update Mappings Failure',
    props<{ error: any }>(),
);
